import { Guid } from "@/Common/Models/Guid";
import { FlowsheetEventHistory } from "./FlowsheetEventHistory";
import { FlowsheetTemplate } from "./FlowsheetTemplate";

export class FlowsheetSummary {
    public Id: Guid;
    public EncounterId: Guid;
    public ApprovalDate?: Date;
    public ApprovedByEmployeeId?: Guid;
    public Template: FlowsheetTemplate;
    public CreationDate: Date;
    public CreatedByEmployeeId: Guid;
    public EventHistory?: FlowsheetEventHistory[];

    constructor(args: Omit<FlowsheetSummary, "proptype">) {
        Object.assign(this, args);
    }
}
